import { Component, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/app/models/company';
import { InventoryService } from 'src/app/services/inventory.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-index-companies',
  template: `
    <div class="d-flex mb-4 mt-4">
      <h1>Inventario</h1>
    </div>
    <div class="d-flex">
    <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
      <ul #sidebar class="list-unstyled">

      </ul>
      <h4 class="mt-1 ms-3 mb-3" style="font-size: 1.2em">Reportes</h4>
      <ul #subnav app-nav-inventory [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
    </div>
    <div #pages class="flex-fill">
      <div class="d-flex">
        <div>
          <div ngbDropdown class="d-inline-block" (click)="datepicker.toggle()">
            <button type="button" class="btn btn-zazz-default rounded-4 px-4 shadow-sm" id="dropdownForm1" ngbDropdownToggle>
              <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
              Este mes
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;">
              <div class="row">
                <div class="col-3">
                  <ul class="list-group calendar-list-group ps-2 mt-2">
                    <li class="list-group-item list-group-item-action active">Hoy</li>
                    <li class="list-group-item list-group-item-action">Ayer</li>
                    <li class="list-group-item list-group-item-action">Este mes</li>
                    <li class="list-group-item list-group-item-action">Últimos 7 días</li>
                    <li class="list-group-item list-group-item-action">Últimos 30 días</li>
                    <li class="list-group-item list-group-item-action">Personalizado</li>
                  </ul>
                </div>
                <div class="col-9" style="height: 320px;">
                  <div class="input-group">
                    <input
                      #dpFromDate
                      class="form-control"
                      style="width: 0px !important; height: 0px !important; opacity: 0;"
                      ngbDatepicker
                      #datepicker="ngbDatepicker"
                      [autoClose]="'outside'"
                      (dateSelect)="onDateSelection($event)"
                      [displayMonths]="2"
                      [dayTemplate]="t"
                      outsideDays="hidden"
                      [startDate]="fromDate!"
                      tabindex="-1" 
                    />
                    <ng-template #t let-date let-focused="focused">
                      <span
                        class="custom-day"
                        [class.focused]="focused"
                        [class.range]="isRange(date)"
                        [class.faded]="isHovered(date) || isInside(date)"
                        (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null"
                      >
                        {{ date.day }}
                      </span>
                    </ng-template>
                  </div>
                </div>
                <div class="col-12">
                  <div class="dropdown-divider"></div>
                  <div class="d-flex text-end flex-fill flex-row-reverse me-2">
                    <button type="button" class="btn btn-zazz-dark ms-2 rounded-4 shadow-sm btn-sm px-4">Aplicar</button>     
                    <button type="button" class="btn btn-zazz-default rounded-4 shadow-sm btn-sm px-4">Cancelar</button>                      
                  </div>                           
                </div>
              </div>                  
            </div>
          </div>
        </div>
        <div class="flex-fill">
          <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm">
            <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
            Filtrar búsqueda
          </button>
        </div>
        <div class="flex-fill">
          <!-- button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" (click)="openModalStockItem()">
            <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
            Agregar
          </button -->
        </div>
        <div class="flex-fill ms-2">
          <!-- input type="text" class="form-control rounded-4 border border-1 border-secondary" placeholder="Buscar recibo" formControlName="search" -->
        </div>
      </div>
      <div class="d-flex mt-4">
        <div class="flex-fill">
          <div class="flex-fill list-group rounded-5 shadow mt-4">
            <div class="list-group-item list-group-item-action">
              <table class="table table-sm table-responsive table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">Nombre</th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Descripción</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Teléfono</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Correo electrónico</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Sitio web</th>
                    <th scope="col" class="bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2">Activo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-company
                    [company]="company"
                    *ngFor="let company of companies"
                  ></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``
})
export class IndexCompaniesComponent {
  companies: Company[] = [];

  currentView = 'companies';

  bills: any = [];
  meta: any = {};
  profile: any = {};
  permissions: any = {};
  searchBox: FormGroup = new FormGroup({});
  a = new Date();
  fromDate; // : any = "2023/12/01"; // Date = new Date();
  toDate; // : any = "2024/02/02"; // Date = new Date();

  payload: any = {
      page: 1,
      per_page: 100,
      status: true,
      state: [0],
      created_at_since: '',
      created_at_to: '',
      sort: 'paid_date',
      order: 'DESC'
    }
    p: number = 1;
  
     payFilterPrefs: any = {};
    
    hoveredDate: NgbDate | null = null;
    storageService = inject(StorageService);
  constructor(
    private invService: InventoryService,
    public icons: IconsService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS);
    this.payload.profile_id = this.profile.id;

    if (this.a.getMonth() == 0) {
      console.log('IS JANUARY');
      this.fromDate = new NgbDate(this.a.getFullYear() - 1, 12, 1);
    } else {
      this.fromDate = new NgbDate(this.a.getFullYear(), this.a.getMonth(), 1);
    }

    console.log('fromDate => ', this.fromDate);

    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, 29);

    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
  }

  ngOnInit(): void {
    this.loadClients();
  }

  loadClients() {
    this.invService.getCompanies({}).subscribe((res: any) => {
      console.log("Companies ==> ", res);
      this.companies = res;
    });
  }

  onDateSelection(date: NgbDate) {
    console.log("date ====> ", date);
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      // this.toDate = null;
      this.fromDate = date;
    }

    // this.router.navigate([], {
      // relativeTo: this.route,
      // queryParams: { 
        // "created_at_since": `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`, 
        // "created_at_to": `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`
      // },
      // queryParamsHandling: 'merge'
    // });

    // this.dateRange.emit({from: this.fromDate, to: this.toDate});
  }

  isHovered(date: NgbDate) {
    return this.fromDate;
    // return (
      // this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    // );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
}
